export default __webpack_public_path__ + "static/after-3-a54172a3f3c9bc54089670f6e9e1e24d.jpeg";